import { useContext } from 'react';
import { useStyletron } from 'baseui';
import { Accordion, Panel } from 'baseui/accordion';
import { ProjectContext } from '../../ProjectApp/context';
import { FlagCheckbox } from './FlagCheckbox';
import { billingFlags, hassleFlags, hubManagedBillingFlags, miscFlags } from './flagLabels';
export const ProjectFlagsAccordion = () => {
  const [css] = useStyletron();
  const ctx = useContext(ProjectContext);
  const flags = ctx.flags();
  const managedByHub = ctx.isManagedByHub();
  return <Accordion accordion overrides={{
    PanelContainer: {
      style: ({
        $theme
      }) => ({
        outline: `1px solid ${$theme.colors.borderOpaque}`,
        borderRadius: '4px',
        borderBottom: 'none',
        marginBottom: '24px'
      })
    }
  }}>
      <Panel title="Hassle Flags">
        <div className={css({
        display: 'grid',
        gridTemplateColumns: '1fr 1fr'
      })}>
          {hassleFlags.map(({
          flag,
          label
        }) => <FlagCheckbox value={!!flags[flag]} label={label} flagProp={flag} />)}
        </div>
      </Panel>
      <Panel title="Billing Flags">
        {managedByHub && <p className={css({
        marginTop: 0
      })} data-testid="hub-managed-flags-notice">
            POC, R&amp;D and exclude-from-billing are set in GTI Hub for this
            project.
          </p>}
        <div className={css({
        display: 'grid',
        gridTemplateColumns: '1fr 1fr'
      })}>
          {billingFlags.map(({
          flag,
          label
        }) => <FlagCheckbox value={!!flags[flag]} label={label} flagProp={flag} disabled={managedByHub && hubManagedBillingFlags.includes(flag)} />)}
        </div>
      </Panel>
      <Panel title="Misc. Flags">
        <div className={css({
        display: 'grid',
        gridTemplateColumns: '1fr 1fr'
      })}>
          {miscFlags.map(({
          flag,
          label
        }) => <FlagCheckbox value={!!flags[flag]} label={label} flagProp={flag} />)}
        </div>
      </Panel>
    </Accordion>;
};